<div class="w-full flex justify-center">
  <div class="max-w-[1800px] w-full">
    <zaeper-page-layout [title]="'Verkäufer werden'" [pageLayout]="ePageLayout.CARDS" [navigation]="navigation">
      <ng-template zTemplate="header">
        <zaeper-icon fontSet="material-icons-outlined">storefront</zaeper-icon>
      </ng-template>

      <div class="flex flex-col gap-6">
        <p-card>
          <ng-template pTemplate="header">
            <div class="px-4 pt-4">
              <h3 class="text-lg font-semibold m-0">Stripe Connect</h3>
              <p class="text-sm text-surface-500 dark:text-surface-400 mt-1">Verkaufe deine Apps, Widgets und Launcher auf dem Marktplatz</p>
            </div>
          </ng-template>

          @if (isLoading) {
            <div class="flex items-center justify-center py-8 text-surface-400 dark:text-surface-500">
              <i class="pi pi-spinner pi-spin text-2xl"></i>
            </div>
          } @else if (!account) {
            <div class="text-center py-8">
              <div class="text-5xl mb-4">
                <i class="pi pi-shop text-surface-300 dark:text-surface-500"></i>
              </div>
              <h4 class="text-lg font-semibold mb-2">Werde Verkäufer auf dem Marktplatz</h4>
              <p class="text-surface-500 dark:text-surface-400 mb-6 max-w-md mx-auto">
                Verbinde dein Bankkonto über Stripe, um deine Inhalte zu verkaufen und Auszahlungen zu erhalten.
              </p>
              <p-button
                label="Onboarding starten"
                icon="pi pi-arrow-right"
                [rounded]="true"
                [loading]="isOnboarding"
                (onClick)="startOnboarding()"/>
            </div>
          } @else {
            <div class="flex flex-col gap-4">
              <div class="flex items-center gap-3">
                <span class="font-medium">Status:</span>
                <p-tag
                  [value]="getOnboardingStatusLabel(account.onboardingStatus)"
                  [severity]="getOnboardingStatusSeverity(account.onboardingStatus)"/>
              </div>

              <div class="grid grid-cols-2 gap-4">
                <div class="p-4 border rounded-lg">
                  <div class="text-sm text-surface-500 dark:text-surface-400 mb-1">Zahlungen empfangen</div>
                  <div class="font-semibold">
                    @if (account.chargesEnabled) {
                      <span class="text-green-600"><i class="pi pi-check-circle mr-1"></i>Aktiviert</span>
                    } @else {
                      <span class="text-yellow-600"><i class="pi pi-clock mr-1"></i>Ausstehend</span>
                    }
                  </div>
                </div>
                <div class="p-4 border rounded-lg">
                  <div class="text-sm text-surface-500 dark:text-surface-400 mb-1">Auszahlungen</div>
                  <div class="font-semibold">
                    @if (account.payoutsEnabled) {
                      <span class="text-green-600"><i class="pi pi-check-circle mr-1"></i>Aktiviert</span>
                    } @else {
                      <span class="text-yellow-600"><i class="pi pi-clock mr-1"></i>Ausstehend</span>
                    }
                  </div>
                </div>
              </div>

              <div class="flex gap-2 pt-2">
                @if (!isOnboarded) {
                  <p-button
                    label="Onboarding fortsetzen"
                    icon="pi pi-arrow-right"
                    [rounded]="true"
                    [outlined]="true"
                    [loading]="isOnboarding"
                    (onClick)="startOnboarding()"/>
                }
                @if (isOnboarded) {
                  <p-button
                    label="Stripe Dashboard öffnen"
                    icon="pi pi-external-link"
                    [rounded]="true"
                    [outlined]="true"
                    (onClick)="openDashboard()"/>
                }
              </div>
            </div>
          }
        </p-card>
      </div>
    </zaeper-page-layout>
  </div>
</div>
